import React from "react";
import { Link } from "react-router-dom";

const ALL = [
  { to: "/", label: "Home" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-of-service", label: "Terms of Service" },
  { to: "/cookie-policy", label: "Cookie Policy" },
  { to: "/accessibility-statement", label: "Accessibility Statement" },
  { to: "/contact", label: "Contact Us" },
];

/**
 * Bottom navigation for legal pages.
 * Standalone links (not inline in prose), so each target is at least
 * 24 px tall per WCAG 2.2 §2.5.8 Target Size (Minimum).
 */
export default function LegalPageNav({ exclude = [] }) {
  const links = ALL.filter((l) => !exclude.includes(l.to));
  return (
    <div className="mt-12 pt-8 border-t border-border">
      <nav aria-label="Related pages" className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
        {links.map((l, i) => (
          <span key={l.to} className="inline-flex items-center gap-x-3">
            {i > 0 && <span aria-hidden="true" className="text-muted-foreground/60">·</span>}
            <Link
              to={l.to}
              className="inline-flex items-center min-h-[24px] py-1 text-primary hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring rounded-sm"
            >
              {l.label}
            </Link>
          </span>
        ))}
      </nav>
    </div>
  );
}